import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './style.scss'

export default class RadioButton extends Component {
    static propTypes = {
        checked: PropTypes.bool,
        containerStyle: PropTypes.object,
        onClickHandler: PropTypes.func.isRequired,
        options: PropTypes.object,
        radioButtonFillStyle: PropTypes.object,
        radioButtonStyle: PropTypes.object,
    }

    static defaultProps = {
        checked: false,
    }

    onClickHandle = () => {
        const { checked, options, onClickHandler } = this.props

        onClickHandler(!checked, options)
    }

    render() {
        const { checked, containerStyle, radioButtonStyle, radioButtonFillStyle } = this.props

        return (
            <div className={'radiobutton-container'} style={{ ...containerStyle }}>
                <div
                    className={classnames('radiobutton', checked && 'checked')}
                    onClick={this.onClickHandle}
                    style={{ ...radioButtonStyle }}
                >
                    <div
                        className={classnames('radiobutton-fill', checked && 'checked')}
                        style={{ ...radioButtonFillStyle }}
                    />
                </div>
            </div>
        )
    }
}
